import qs from 'query-string';

export const getQueryParameters = (searchParams) => {
    return qs.parse(searchParams, { ignoreQueryPrefix: true });
}